import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownV2SelectionService {

  private subject: Subject<string>;

  constructor() {
    this.subject = new Subject<string>();
  }

  public setCarrierCode = (id: string): void => {
    this.subject.next(id);
  }

  public getCarrierCode = (): Observable<string> => {
    return this.subject.asObservable();
  }
}
